module.exports = __webpack_public_path__ + "img/b0309_14.5bc410ac.png";